import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getStaffProfileDetailUrl, updateStaffDetailsUrl } from '../../assets/api/BaseURL'; // Update this path as needed

export default function StaffProfile() {
  const [user, setUser] = useState({
    name: '',
    phone_number: '',
    username: '',
    email: '',
    address: '',
  });

  const [token, setToken] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Dummy toast function - replace with your toast handler
  const addToast = (type, msg) => {
    console.log(`${type.toUpperCase()}: ${msg}`);
  };

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    setToken(savedToken);
  }, []);

  useEffect(() => {
    if (token) {
      const fetchStaffProfile = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(getStaffProfileDetailUrl, {
            headers: { authorization: `Bearer ${token}` },
          });

          if (response.status === 200 && response.data.data) {
            const data = response.data.data;
            setUser({
              name: data.name || '',
              phone_number: data.phone_number || '',
              username: data.username || '',
              email: data.email || '',
              address: data.address || '',
            });
          }
        } catch (err) {
          addToast('error', err?.response?.data?.message || err.message);
        }
        setIsLoading(false);
      };

      fetchStaffProfile();
    }
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();

    if (!user.name.trim()) {
      setError('Name is required.');
      setSuccess('');
      return;
    }

    if (!user.phone_number.trim()) {
      setError('Phone number is required.');
      setSuccess('');
      return;
    }

    if (!user.username.trim()) {
      setError('Username is required.');
      setSuccess('');
      return;
    }

    try {
      // Replace with your actual update API endpoint
      const response = await axios.put(updateStaffDetailsUrl, user, {
        headers: { authorization: `Bearer ${token}` },
      });

      if (response.data.status === 'success') {
        setSuccess('Profile updated successfully.');
        setError('');
      } else {
        setError('Failed to update profile.');
        setSuccess('');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong.');
      setSuccess('');
    }
  };

  return (
    <div className="col-lg-8 d-flex flex-column">
      <div className="row flex-grow">
        <div className="col-12 grid-margin">
          <div className="card card-rounded">
            <div className="card-body">
              <h4 className="card-title">Contact Details</h4>

              <form className="forms-sample" onSubmit={handleUpdateProfile}>
                {error && (
                  <div className="alert alert-danger d-flex justify-content-between">
                    <div>{error}</div>
                    <span
                      className="text-muted"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setError('')}
                    >
                      ×
                    </span>
                  </div>
                )}

                {success && (
                  <div className="alert alert-success d-flex justify-content-between">
                    <div>{success}</div>
                    <span
                      className="text-muted"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setSuccess('')}
                    >
                      ×
                    </span>
                  </div>
                )}

                <div className="form-group">
                  <label>
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={user.name}
                    onChange={handleChange}
                    placeholder="Full Name"
                  />
                </div>

                <div className="form-group">
                  <label>
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone_number"
                    value={user.phone_number}
                    onChange={handleChange}
                    maxLength={10}
                    placeholder="Phone Number"
                  />
                </div>

                <div className="form-group">
                  <label>
                    Username <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    value={user.username}
                    onChange={handleChange}
                    placeholder="Username"
                  />
                </div>

                <div className="form-group">
                  <label>
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={user.email}
                    onChange={handleChange}
                    placeholder="Email"
                  />
                </div>

                <div className="form-group">
                  <label>Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={user.address}
                    onChange={handleChange}
                    placeholder="Address"
                  />
                </div>

                <button type="submit" className="btn btn-primary me-2">
                  Save
                </button>
              </form>

              {/* {isLoading && <p className="mt-3 text-muted">Loading...</p>} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
